import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import * as s from "./index.module.scss";
// import FormComponent from '@/components/Common/LoanForm/Form'
import secondaryFont from "@/utils/secondaryFont";
import LoanForm from "@/components/Common/LoanForm/Form";

const PersonalLoans = ({ data }) => {
  return (
    <section className={`section-center ${s.collateral_loans}`}>
      <Container>
        <div className={`text-center ${s.header}`}>
          {/* <h4>
                    {data?.caption}
                </h4> */}
          <h2 className="fw-bold">{data?.title}</h2>
          <p className={`${secondaryFont} ${s.desc_text}`}>{data?.desc}</p>
          {/* <div className={s.arrow_container}>
                  <img src={Arrow.src} alt="image" />
                </div> */}
        </div>

        <div className={s.body}>
          <Row className={`align-items-md-center`}>
            <Col md={7} xxl={6}>
              {/* <FormComponent/>*/}
              <LoanForm page={"Collateral Loans"} />
            </Col>
            <Col md={5} className={s.items_wrapper}>
              {data?.item?.map(({ image, text }, idx) => {
                return (
                  <div key={idx} className={s.single_item}>
                    <img
                      loading="lazy"
                      src={image.url}
                      alt={image.alt || "image"}
                      height="100%"
                    />
                    <div>
                      <p
                        loading="lazy"
                        className={`${secondaryFont} ${s.desc}`}
                      >
                        {text}
                      </p>
                      {/* <IoChevronForward size="24px" style={{marginLeft: "12px"}} /> */}
                    </div>
                  </div>
                );
              })}
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default PersonalLoans;
